module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('y-shelf', {
    attrs: {
      "title": "XPay收银台 收款方: Exrick"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "box-inner order-info"
  }, [_c('p', {
    staticClass: "payment-detail"
  }, [_vm._v("扫一扫付款（元）")]), _vm._v(" "), _c('p', {
    staticClass: "payment-money"
  }, [_vm._v(_vm._s(_vm.orderTotal))]), _vm._v(" "), _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "pic",
    attrs: {
      "id": "qr",
      "src": _vm.imgPath,
      "alt": "加载失败",
      "width": "168px",
      "height": "168px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_c('img', {
    staticClass: "fn-left",
    attrs: {
      "src": "https://t.alipayobjects.com/images/T1bdtfXfdiXXXXXXXX.png",
      "alt": "扫一扫标识"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fn-right"
  }, [_vm._v("打开手机支付宝"), _c('br'), _vm._v("扫一扫继续付款")]), _vm._v(" "), (_vm.timeout) ? _c('div', {
    staticClass: "timeout"
  }, [_vm._v("二维码已过期")]) : _vm._e()])]), _vm._v(" "), _c('a', {
    staticClass: "download-alipay",
    attrs: {
      "href": "https://mobile.alipay.com/index.htm",
      "target": "_blank"
    }
  }, [_vm._v("首次使用请下载手机支付宝")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.timecount))]), _vm._v(" "), _c('div', {
    staticClass: "qrguide-area"
  }, [_c('img', {
    class: _vm.show ? 'show-img' : 'close-img',
    attrs: {
      "src": "https://t.alipayobjects.com/images/rmsweb/T13CpgXf8mXXXXXXXX.png"
    },
    on: {
      "click": function($event) {
        return _vm.changePic()
      }
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.show ? 'close-img' : 'show-img',
    attrs: {
      "src": "https://t.alipayobjects.com/images/rmsweb/T1ASFgXdtnXXXXXXXX.png"
    },
    on: {
      "click": function($event) {
        return _vm.changePic()
      }
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "red",
    attrs: {
      "src": "/static/images/red.png",
      "width": "50px",
      "height": "50px",
      "title": "支付领红包"
    },
    on: {
      "click": function($event) {
        return _vm.showRed()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box-btn"
  }, [_c('div', [_c('span'), _vm._v(" "), _c('em', [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(_vm.orderTotal))]), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "width": "120px",
      "height": "40px",
      "font-size": "16px",
      "line-height": "38px"
    },
    attrs: {
      "text": _vm.payNow,
      "classStyle": _vm.submit ? 'main-btn' : 'disabled-btn'
    },
    on: {
      "btnClick": function($event) {
        return _vm.paySuc()
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "text-align": "center",
      "width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "title": "支付红包",
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('img', {
    staticClass: "qr-red",
    attrs: {
      "src": "http://oweupqzdv.bkt.clouddn.com/1512881761970_small.jpg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("支付前领个红包吧(每日可领一次)")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("领取了")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9849ed6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/alipay.vue
// module id = 779
// module chunks = 2